var site = site || {};
site.inits = [];

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {
		site.owl.init('#custom-quotes .items', {
			items: 1,
			nav: true,
			dots: false,
		});
	},
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	}
});

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

document.addEventListener("DOMContentLoaded", () => {
	setTimeout(() => {
		$('.level1.children > .expand', '#mainmenu').each(function() {
			$(this).next("a").andSelf().wrapAll("<div class='inner' />")
		});
		$('.level1 > a', '#mainmenu').each(function() {
			$(this).wrapAll("<div class='inner' />")
		});

		$('.inner button', '#mainmenu').on('click', function() {
			$(this).closest('li').siblings().removeClass('down').removeClass('selectedLevel1');

			if ($('.level1.down', '#mainmenu').length) {
				document.body.classList.add('mainmenu-level2-open');
				setMainmenuMinHeight($(this).closest('li').find('.mmLevel2'));
			}
			else {
				document.body.classList.remove('mainmenu-level2-open');
				setMainmenuMinHeight();
			}
		});

		if ($('.level1.down.children', '#mainmenu').length) {
			document.body.classList.add('mainmenu-level2-open');
			setMainmenuMinHeight($('.level1.down.children', '#mainmenu').find('.mmLevel2'));
		}
	},1);
});

const setMainmenuMinHeight = (mmLevel2) => {
	document.querySelector('#mainmenu').removeAttribute('style');
	if (mmLevel2 === undefined) {
		return false;
	}

	const level2Count = mmLevel2[0].childElementCount ?? 0;
	if (level2Count) {
		document.querySelector('#mainmenu').style.minHeight = (level2Count * 60 + 123 + 123) + 'px'
	}
}
